// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__S5p2m","messages":"Chat_messages__U0lQt","dateDivider":"Chat_dateDivider__1S2Kk"};